import { zodSchemes } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { useMemo } from 'react';
import { z } from 'zod';

export const useSchema = (fieldValues: domain.RequestFieldEntry[]) => {
    return useMemo(
        () => ({
            schema: z.object(
                fieldValues.reduce<Record<string, z.ZodType<string | null>>>((acc, fieldValue) => {
                    acc[fieldValue.field.id] = zodSchemes.required.select.string();

                    return acc;
                }, {})
            ),
        }),
        [fieldValues]
    );
};
